<script>
  import resources from './resources'
  export default {
    name: 'overview',
    mixins: [resources]
  }
</script>

<template lang="pug">
#overview.tab-pane.active(role='tabpanel')
  .row
    .col-lg-3.col-md-6.col-6
      .card.text-center
        .body
          i.zmdi.zmdi-balance.zmdi-hc-2x
          h5.m-b-0.number.count-to
             count-to(:startVal='0' separator="" :endVal='Number(statistics.units)' :duration=1)
          small Unidade(s)
    .col-lg-3.col-md-6.col-6
      .card.text-center
        .body
          i.zmdi.zmdi-swap.zmdi-hc-2x
          h5.m-b-0.number.count-to
            count-to(:startVal='0' separator="" :endVal='Number(statistics.parkingLoans)' :duration=1)
          small Empréstimo(s)
    .col-lg-3.col-md-6.col-6
      .card.text-center
        .body
          i.zmdi.zmdi-store.zmdi-hc-2x
          h5.m-b-0.number.count-to
            count-to(:startVal='0' separator="" :endVal='Number(statistics.schedules)' :duration=1)
          small Reserva(s)
    .col-lg-3.col-md-6.col-6
      .card.text-center
        .body
          i.zmdi.zmdi-car.zmdi-hc-2x
          h5.m-b-0.number.count-to
            count-to(:startVal='0' separator="" :endVal='Number(statistics.cars)' :duration=1)
          small Carro(s)
  .row
    .col-lg-4.col-md-12
      info
    .col-lg-8.col-md-12
      feed
</template>



// WEBPACK FOOTER //
// src/app/dweller/profile/me/components/overview/overview.vue